import { useEffect, Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Loader from './components/Loader';
import { getRoutes } from './routes';
import PageContent from './pages/PageContent';

// ADDED — protected route component
function ProtectedRoute({ children }) {
    const { isSignedIn, isLoaded } = useUser();
    if (!isLoaded) return null;
    if (!isSignedIn) return <Navigate to="/" replace />;
    return children;
}

function App() {
    const { isLoaded, userId } = useAuth();
    if (!isLoaded) return <Loader />;
    return <AppRoutes userId={userId} />;
}

function AppRoutes({ userId }) {
    const router = useRoutes(getRoutes(!!userId));
    useEffect(() => {
        document.title = 'Jerny';
    }, []);
    return (
        <PageContent>
            <ToastContainer progressClassName="toast-progress" />
            <Suspense fallback={<Loader />}>{router}</Suspense>
        </PageContent>
    );
}

export default App;
